export function PrepareParams(params) {
  const paramsArray = [];
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      if (key === 'paging') {
        paramsArray.push(`pageOffset=${params[key].offset}`);
        paramsArray.push(`pageLimit=${params[key].limit}`);
      } else if (key === 'sorting') {
        paramsArray.push(`sortProperty=${params[key].propertyName}`);
        paramsArray.push(`sortType=${params[key].sortingType}`);
      } else {
        paramsArray.push(`${key}=${params[key]}`);
      }
    }
  }
  return encodeURI(paramsArray.join('&'));
}

